import * as Yup from 'yup'

export const buildValidationSchema = () => Yup.object().shape({
  amount_cents: Yup.number()
    .typeError(I18n.t('donate.errors.invalid'))
    .min(100, I18n.t('donate.errors.greater_than'))
    .max(2000000, I18n.t('donate.errors.exceeds_platform_limit')),
  display_name: Yup.string()
    .max(255, I18n.t('donate.errors.too_long')),
  first_name: Yup.string()
    .max(255, I18n.t('donate.errors.too_long'))
    .required(I18n.t('donate.errors.blank')),
  last_name: Yup.string()
    .max(255, I18n.t('donate.errors.too_long'))
    .required(I18n.t('donate.errors.blank')),
  _company_donation: Yup.boolean(),
  receipt_desired: Yup.boolean(),
  company_name: Yup.string()
    .when('_company_donation', {
      is: true,
      then: Yup.string()
        .required(I18n.t('donate.errors.blank')),
    }),
  street: Yup.string()
    .when('receipt_desired', {
      is: true,
      then: Yup.string()
        .max(255, I18n.t('donate.errors.too_long'))
        .required(I18n.t('donate.errors.blank')),
    }),
  city: Yup.string()
    .when('receipt_desired', {
      is: true,
      then: Yup.string()
        .max(255, I18n.t('donate.errors.too_long'))
        .required(I18n.t('donate.errors.blank')),
    }),
  zip: Yup.string()
    .when('receipt_desired', {
      is: true,
      then: Yup.string()
        .max(255, I18n.t('donate.errors.too_long'))
        .required(I18n.t('donate.errors.blank')),
    }),
  email: Yup.string()
    .email(I18n.t('donate.errors.invalid'))
    .max(255, I18n.t('donate.errors.too_long'))
    .required(I18n.t('donate.errors.blank')),
})
